<template>
    <div class="assistant">
        <div class="content" v-watermark>
            <div class="header">将用户转移至</div>
            <van-radio-group v-model="transferAssistantNo">
                <van-cell-group>
                    <van-cell
                        v-for="item in list"
                        clickable
                        :key="item.id"
                        @click="toggle(item)"
                    >
                        <template #title>
                            <div class="title">
                                <img :src="item.photo" alt="">
                                <span>{{item.name}}</span>
                            </div>
                        </template>
                        <template #right-icon>
                            <van-radio :name="item.assistantNo" shape="square" />
                        </template>
                    </van-cell>
                </van-cell-group>
            </van-radio-group>
            <pagination :total="total" :pageSize="searchData.pageSize" @pageChange="pageChange" v-if="total > 10"></pagination>
        </div>
        <div class="footer">
            <van-button type="default" @click="cancel">取 消</van-button>
            <van-button type="info" :disabled="!transferAssistantNo" @click="transferUserInfo">确 定</van-button>
        </div>
    </div>
</template>
<script>
    import { getDoctorAssistan, transferUserInfo } from '../../api/home.js'
    export default {
        data() {
            return {
                list: [],
                total: 0,
                transferAssistantNo: '',
                name: '',
                searchData: {
                    pageNo: 1,
                    pageSize: 10,
                    assistantNo: ''
                },
                userNos: []
            }
        },
        created() {
            this.searchData.assistantNo = this.$store.state.assistantNo
            this.userNos = JSON.parse(sessionStorage.getItem('userNos'))
            this.getDoctorAssistan()
        },
        methods: {
            getDoctorAssistan() {
                getDoctorAssistan(this.searchData).then(res => {
                    if(res.code == 0){
                        this.list = res.data.list
                        this.total = res.data.total
                    }
                })
            },
            pageChange(pageNo){
                this.searchData.pageNo = pageNo
                this.getDoctorAssistan()
            },
            toggle(item){
                this.transferAssistantNo = item.assistantNo
                this.name = item.name
            },
            transferUserInfo() {
                let name = this.name
                let num = this.userNos.length
                this.$dialog.confirm({
                    title: '用户转移提示',
                    message: `确定将本人关联的${num}位患者全部转移至健康管家${name}？<span style="color: #ee0a24">如有进行中的问诊，将会一同转移给转移后医助所绑定的医生。</span>`,
                    allowHtml: true
                }).then(() => {
                    let data = {
                        transferAssistantNo: this.transferAssistantNo,
                        userNos: this.userNos
                    }
                    transferUserInfo(data).then(res => {
                        if(res.code == 0){
                            this.$toast.success('转移成功')
                            setTimeout(() => {
                                this.$router.back()
                            }, 1500);
                        }
                    })
                }).catch(() => {

                })
            },
            cancel() {
                this.$router.back()
            }
        }
    }
</script>
<style lang="scss" scoped>
.assistant {
    padding: 10px;
    .content {
        background: #fff;
        height: calc(100vh - #{'104px'});
        border-radius: 4px;
        overflow-y: scroll;
        padding: 0 16px;
        .header {
            padding: 20px 0;
            color: #333;
            font-weight: bold;
            font-size: 18px;
        }
        .van-cell-group,
        .van-cell {
            background-color: transparent;
        }
        .van-cell {
            padding-left: 0;
            padding-right: 0;
            width: auto;
            font-size: 16px;
        }
        .van-cell::after {
            left: 0;
            right: 0;
        }
        .title {
            display: flex;
            align-items: center;
            font-size: 14px;
            color: #333;
            img {
                width: 38px;
                height: 38px;
                border-radius: 50%;
                margin-right: 10px;
            }
        }
        :deep() .van-radio__icon {
            font-size: 18px;
            .van-icon {
                width: 18px;
                height: 18px;
                line-height: 18px;
            }
        }
    }
    .footer {
        height: 84px;
        background: #fff;
        position: fixed;
        left: 0;
        right: 0;
        bottom: 0;
        display: flex;
        justify-content: space-around;
        align-items: center;
        .van-button {
            width: 45%;
        }
    }
}
</style>